var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-device-setting-modal-component" }, [
    _c(
      "div",
      { staticClass: "room-device-setting-modal" },
      [_c("DeviceSettingPreview")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }